(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }


  customElements.define('sticky-header', StickyHeader);

  const apeSearch = document.querySelector('[data-ape-home-search]');
  if (apeSearch) {
    const input = apeSearch.querySelector('[data-ape-search-input]');
    const results = apeSearch.querySelector('[data-ape-search-results]');
    let timer;
    let controller;

    const closeResults = () => {
      results.replaceChildren();
      results.classList.remove('is-visible');
      input.setAttribute('aria-expanded', 'false');
    };

    const showResults = () => {
      results.classList.add('is-visible');
      input.setAttribute('aria-expanded', 'true');
    };

    const addResult = (product) => {
      const link = document.createElement('a');
      link.className = 'ape-home-search__result';
      link.href = product.url;
      link.setAttribute('role', 'option');

      if (product.image) {
        const image = document.createElement('img');
        image.className = 'ape-home-search__image';
        image.src = product.image;
        image.alt = '';
        image.width = 44;
        image.height = 44;
        link.append(image);
      }

      const title = document.createElement('span');
      title.textContent = product.title;
      link.append(title);
      results.append(link);
    };

    const fetchResults = async () => {
      const query = input.value.trim();

      if (query.length < 2) {
        closeResults();
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      try {
        const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        const url = new URL('search/suggest.json', window.location.origin + root);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');

        const response = await fetch(url, {
          signal: controller.signal,
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Search request failed');

        const data = await response.json();
        const products = data.resources.results.products || [];
        results.replaceChildren();

        if (products.length) {
          products.forEach(addResult);
        } else {
          const message = document.createElement('p');
          message.className = 'ape-home-search__empty';
          message.textContent = 'No matching parts found.';
          results.append(message);
        }

        showResults();
      } catch (error) {
        if (error.name !== 'AbortError') closeResults();
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(fetchResults, 220);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2 && results.childElementCount) showResults();
    });

    document.addEventListener('click', (event) => {
      if (!apeSearch.contains(event.target)) closeResults();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeResults();
        input.blur();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
